<template>
  <div class="login">
    <el-row class="el-row">
      <el-col :span="16" class="el-colss">
        <el-row class="el-row el-rows">
          <el-col :span="10" class="el-cols">
            <div class="cenformbox">
              <h1>湖南96320转运车管理中心</h1>
              <el-form :model="form" ref="Loginrulesref" :rules="Loginrules">
                <el-form-item prop="userName">
                  <el-input v-model="form.userName" prefix-icon="el-icon-user-solid"></el-input>
                </el-form-item>
                <el-form-item prop="passwd">
                  <el-input class="el-input" type="password" v-model="form.passwd" show-passwd
                    prefix-icon="el-icon-lock" @keyup.enter.native="logintj"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button class="el-button" type="primary" @click="logintj">提交</el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-col>

          
          <el-col :span="14" class="el-cols image-col" style="width: 300px;">
            <img src="/fonts/home_logo.png" @click="getcodeimg" class="login-image" />
          </el-col>

        </el-row>
       <!-- <el-footer style="position: absolute;top: 92%;text-align: center;font-size: 15px;right: 35%;font-weight: 400;">
          <div class="footer">湖南96320服务平台 Copyright 2013-2026 ©版权所有 湘ICP备2020023409号-1</div>
        </el-footer> -->
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'login',
  data() {
    return {
      form: {
        userName: '',
        passwd: ''
      },
      Loginrules: {
        userName: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 2, max: 16, message: '长度在 2 到 16 个字符', trigger: 'blur' }
        ],
        passwd: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 3, max: 18, message: '长度在 3 到 18 个字符', trigger: 'blur' }
        ]
      },
      btnsList: []
    }
  },
  methods: {
    getcodeimg() {},
    logintj() {
      this.$refs.Loginrulesref.validate(async valid => {
        if (!valid) return
        const res = await this.$http.post('/account/user/login', JSON.parse(JSON.stringify(this.form)))
        if (res.data.result !== 'true') return this.$message.error(res.data.resultDesc)
        this.$message({ message: '登录成功', type: 'success', duration: '1000' })
        sessionStorage.setItem('userId', res.data.data.user.uuid)
        sessionStorage.setItem('token', res.data.data.token)
        sessionStorage.setItem('userName', res.data.data.user.userName)
        sessionStorage.setItem('companyId', res.data.data.user.corpId)
        sessionStorage.setItem('phone', res.data.data.user.mobilePhone)
        sessionStorage.setItem('passwd', res.data.data.user.passwd)
        try {
          await this.getorderCompany(res.data.data.user)
        } catch { console.log('暂无接口') }
        this.getList()
      })
    },
    async getorderCompany(data) {
      const { uuid, corpId } = data
      const obj = { userId: uuid, corpId }
      const res = await this.$http.post('userManageServer/area/selectRoleBybaseId', obj)
      this.$store.dispatch('SET_ORDER', res.data.data)
    },
    async getList() {
      const { data: res } = await this.$http.post('/userManageServer/user/selectMenuList', {
        applicationCode: '10000', userId: sessionStorage.getItem('userId')
      })
      if (res.statusCode !== '200') return this.$message.error('获取用户菜单失败')
      if (res.data instanceof Array) {
        sessionStorage.setItem('headerNav', JSON.stringify(res.data))
        this.$router.push('/system')
      }
      var asyncRputer = []
      res.data.forEach(item => {
        var obj = {
          path: item.menuUrl,
          name: item.menuUrl.split('/').join(''),
          component: eval(`() => import('@/views${item.menuUrl}${item.menuUrl}.vue')`),
          meta: { bread: { title: item.menuName }, path: item.menuUrl },
          children: []
        }
        item.twoMenusList.forEach(i => {
          var ob = {
            path: i.menuUrl, name: i.menuUrl.split('/').pop(),
            component: eval(`() => import('@/views/${i.menuUrl.split('/').pop()}/${i.menuUrl.split('/').pop()}.vue')`),
            meta: { bread: { title: item.menuName, children: { title: i.menuName } } }, children: []
          }
          obj.children.push(ob)
          i.twoMenusList.forEach(k => {
            var o = {
              path: k.menuUrl, name: k.menuUrl.split('/').pop(),
              component: eval(`() => import('@/views/${k.menuUrl.split('/').pop()}/${k.menuUrl.split('/').pop()}.vue')`),
              meta: { bread: { title: item.menuName, children: { title: i.menuName, children: { title: k.menuName } } } }
            }
            ob.children.push(o)
          })
        })
        asyncRputer.push(obj)
      })
      sessionStorage.setItem('asyncRputer', JSON.stringify(asyncRputer))
      this.btnList(res.data)
      await this.getbtnZuständigkeit()
    },
    btnList(v) {
      v.forEach(item => {
        if (item.twoMenusList && item.twoMenusList.length > 0) {
          this.btnList(item.twoMenusList)
        } else {
          this.btnsList.push(item.uuid)
        }
      })
      sessionStorage.setItem('btnList', JSON.stringify(this.btnsList))
    },
    async getbtnZuständigkeit() {
      const { data: res } = await this.$http.post('/userManageServer/user/selectBtnList', {
        userId: sessionStorage.getItem('userId')
      })
      if (res.statusCode === '200') {
        this.$store.commit('SET_ROLES', res.data)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.login {
  background-image: url("../../assets/img_login_page_bg@2x.jpg");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 100%;

  .el-row {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;

    .el-colss {
      height: 100%;
      box-sizing: border-box;

      .el-rows {
        display: flex;
        align-items: center;
      }

      .el-cols {
        height: 500px;

        .cenformbox {
          height: 100%;
          background-color: #fff;
		  border-radius: 16px 0 0 16px;
          box-sizing: border-box;
          padding: 60px 40px;

          h1 {
            text-align: center;
            color: #409eff;
          }

          .el-form-item {
            width: 100%;
            margin-top: 40px;
          }

          .el-input {
            width: 100%;
          }

          .el-button {
            width: 100%;
            height: 60px;
            margin-top: 20px;
            background: linear-gradient(90deg, #5798ff, #0094f9);
            box-shadow: 0px 6px 15px 0px rgba(98, 190, 254, 0.77);
            border-radius: 10px;
          }
        }
      }

      /* 👇 核心修复：图片完整显示、居中、无空白、对齐 */
      .image-col {
        display: flex;
		padding-right: 25px;
        align-items: center;
        justify-content: center;
		border-radius: 0 16px 16px 0;
        background: #fff;
        overflow: hidden;
      }

      .login-image {
        width: 100%;
        height: 100%;
        object-fit: contain;       /* 完整显示不裁切 */
        object-position: center;   /* 居中 */
        display: block;            /* 去掉空白 */
      }
    }
  }
}
</style>